export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4781.75a0c1f8.jpg";